class AddToFavorites {
	constructor() {
		this.favoriteAdventures = JSON.parse(localStorage.getItem('favoriteAdventures'));
		if (null === this.favoriteAdventures) {
			this.favoriteAdventures = [];
			localStorage.setItem('favoriteAdventures', JSON.stringify(this.favoriteAdventures));
		}
	}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		this.$buttons = document.querySelectorAll(
			'.component-add-to-favorites'
		);
		this.$buttons.forEach((el, i) => {
			el.addEventListener('click', () => {
				if (this.isFavorite(el.dataset.adventure)) {
					this.removeFromFavorites(el.dataset.adventure);
				} else {
					this.addToFavorites(el.dataset.adventure);
				}
			});
		});
	}
	addToFavorites(adventure) {
		this.favoriteAdventures.push(adventure);
		localStorage.setItem('favoriteAdventures', JSON.stringify(this.favoriteAdventures));
		this.styleFavorites();
		const $favoritesButton = document.querySelector('.main-header__favorites');
		$favoritesButton.classList.add('main-header__favorites_active');
	}
	removeFromFavorites(adventure) {
		const index = this.favoriteAdventures.indexOf(adventure.toString());
		this.favoriteAdventures.splice(index, 1);
		localStorage.setItem('favoriteAdventures', JSON.stringify(this.favoriteAdventures));
		this.styleFavorites();
		const $favoritesButton = document.querySelector('.main-header__favorites');
		if (this.favoriteAdventures.length === 0) {
			$favoritesButton.classList.remove('main-header__favorites_active');
		}
	}
	isFavorite(adventure) {
		if (!this.favoriteAdventures.includes(adventure.toString())) {
			return false;
		}
		return true;
	}
	styleFavorites() {
		this.$buttons.forEach((el, i) => {
			if (this.favoriteAdventures.includes(el.dataset.adventure.toString())) {
				el.classList.add('component-add-to-favorites--is-favorite');
			} else {
				el.classList.remove('component-add-to-favorites--is-favorite');
			}
		});
	}
}

const newAddToFavorites = new AddToFavorites();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		newAddToFavorites.init();
		newAddToFavorites.styleFavorites();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
	pageHeightChange() {
		newAddToFavorites.init();
		newAddToFavorites.styleFavorites();
	},
};
export default controller;
